import { getRiskLevels } from '../../../../utils/data';
import { getItemStyle } from '../../../../utils/utilities';
import { PDFImageProps, RiskLevel, VTAnomalyData } from '../../../../utils/models';
import Conditional from '../../../common/conditional';

import css from '../pdf.module.scss';

interface VTPipingAnomalyProps {
	data: VTAnomalyData[];
	vtPipingReportSummary: string;
}

const VTPipingAnomaly = (props: VTPipingAnomalyProps) => {
	const riskLevels: RiskLevel[] = getRiskLevels();

	return (
		<div className={css['pdf-anomaly-data']}>
			<Conditional isVisible={props.vtPipingReportSummary.length > 0}>
				<div className={css['title-grid-value']}>
					{props.vtPipingReportSummary}
				</div>
			</Conditional>

			<div className="container-fluid overflow-hidden">
				{props.data.map((item: VTAnomalyData) => {
					const itemStyle = getItemStyle(item);

					return (
						<div
							className={css['pdf-anomaly-data-item'] + ' row'}
							key={item.id}
						>
							<div className="col-sm-6 p-0">
								<div className="container-fluid overflow-hidden">
									<div className="row">
										<div
											className={css['pdf-anomaly-data-item-box'] + ' col-4'}
										>
											Anomaly Category
										</div>
										<div className={css['pdf-anomaly-data-item-box'] + ' p-0'}>
											<div className="row w-100">
												{riskLevels.map((risk) => (
													<div className="col p-0">
														<div className={css['pdf-anomaly-data-item-box']}>
															{risk.level}
														</div>
														<div
															className={css['pdf-anomaly-data-item-box']}
															style={{
																backgroundColor: risk.backgroundColor,
																color: risk.textColor,
															}}
														>
															{risk.backgroundColor}
														</div>
													</div>
												))}
											</div>
										</div>
									</div>
								</div>
								<div className="d-flex">
									<div className={css['pdf-anomaly-data-item-box']}>
										Anomaly #{item.id}
									</div>

									<div
										className={css['pdf-anomaly-data-item-box']}
										style={itemStyle}
									>
										{item.level}
									</div>
								</div>
								<Conditional isVisible={!!item.location}>
									<div className="d-flex">
										<div className={css['pdf-anomaly-data-item-box']}>
											Location
										</div>

										<div className={css['pdf-anomaly-data-item-box']}>
											{item.location}
										</div>
									</div>
								</Conditional>
								<div className="d-flex">
									<div className={css['pdf-anomaly-data-item-box']}>
										Recommendation
									</div>
									<div className={css['pdf-anomaly-data-item-box']}>
										{item.recommendation}
									</div>
								</div>
								<div className={css['pdf-anomaly-data-item-box']}>
									Description
								</div>
								<div
									className={css['pdf-anomaly-data-item-box']}
									style={itemStyle}
								>
									{item.description}
								</div>
							</div>
							<div className="col-sm-6 p-3 border-dark">
								{item.images.slice(0, 2).map((image: PDFImageProps) => (
									<img
										src={image.src}
										alt={image.caption}
										className={css['pdf-anomaly-data-item-image']}
										style={{
											borderColor: itemStyle?.backgroundColor,
										}}
									/>
								))}
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default VTPipingAnomaly;
